import React from 'react'
import { Box, Typography, Accordion, AccordionDetails, AccordionSummary, Stack, Button, CircularProgress } from '@mui/material'
import { ChargingCardStatusChip } from 'src/Libs/e-mobility/shared/components/ChargingCardStatusChip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useTableStyles } from 'src/Libs/e-mobility/shared/styles/table.styles'
import { J1DownarrowD } from '@e3dc-react/icons'
import { Control } from 'react-hook-form'
import { WallboxModel } from 'src/Libs/e-mobility/wallboxes'
import { CardStatus } from 'src/Libs/e-mobility/shared'
import { ChargingCardToWallboxFormData } from '../charging-card-to-wallbox-form-data'
import { ChargingCardMobileWallboxCell } from './ChargingCardMobileWallboxCell'

interface ChargingCardToWallboxLinkRowItemProps {
  installationId: number
  wallboxes: WallboxModel[]
  ocpiTokenId: string
  shouldDisableRow: boolean
  shouldDisableButtons: boolean
  shouldButtonsBeVisible: boolean
  cardUser: string | null
  cardStatus: CardStatus
  cardName: string | null
  control: Control<ChargingCardToWallboxFormData>
  handleSubmit: () => void
  handleCancelButtonClick: () => void
}

/**
 * Component for displaying one row for table on mobile and tablet screens inside charging card to link wallboxes dialog
 */
export const ChargingCardToWallboxLinkRowItem: React.FC<ChargingCardToWallboxLinkRowItemProps> = ({
  installationId,
  wallboxes,
  ocpiTokenId,
  shouldDisableRow,
  shouldDisableButtons,
  shouldButtonsBeVisible,
  cardName,
  cardStatus,
  cardUser,
  control,
  handleSubmit,
  handleCancelButtonClick,
}) => {
  const { t } = useCustomTranslation()
  const { classes } = useTableStyles()

  return (
    <Accordion elevation={0} className={classes.accordion}>
      <AccordionSummary className={classes.accordionSummary} expandIcon={<J1DownarrowD />} disabled={shouldDisableRow}>
        <Stack direction="row" p={1} justifyContent="space-between" width="100%">
          <Stack direction="column" minWidth={100} alignSelf="center" flex={1}>
            <Typography variant="subtitle1">{cardName}</Typography>
            {cardUser && <Typography variant="body2">{cardUser}</Typography>}
          </Stack>
          <Box alignSelf="center" ml={2}>
            <ChargingCardStatusChip status={cardStatus} />
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        {wallboxes.map(wallbox => (
          <ChargingCardMobileWallboxCell
            key={wallbox.wallboxId}
            wallboxId={wallbox.wallboxId}
            installationId={installationId}
            control={control}
            shouldDisableButtons={shouldDisableButtons}
            ocpiTokenId={ocpiTokenId}
          />
        ))}
        <Stack
          mt={2}
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          sx={{ visibility: shouldButtonsBeVisible ? 'visible' : 'hidden' }}
        >
          <Button variant="text" color="inherit" onClick={handleCancelButtonClick} disabled={shouldDisableButtons} sx={{ marginRight: 2 }}>
            {t('common.cancel')}
          </Button>
          <Button variant="contained" onClick={handleSubmit} disabled={shouldDisableButtons}>
            {shouldDisableButtons ? <CircularProgress size={15} /> : t('common.save')}
          </Button>
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
